import React, { ReactNode, useContext } from "react";
import Header from "./Header/Header";
import Auth from "./Auth";
import { CMSModal } from "@/context";
import { twMerge } from "tailwind-merge";

const Layout = ({ children }: { children: ReactNode }) => {
  const { theme } = useContext(CMSModal);
  return (
    <div
      className={twMerge(
        "flex flex-col min-h-screen h-full transition-colors",
        theme === "dark"
          ? "bg-[#262727] text-gray-100"
          : "bg-gray-100 text-[#3b3b3b]",
      )}
    >
      <Header />
      <main className="z-1">
        <Auth>{children}</Auth>
      </main>
    </div>
  );
};

export default Layout;
